import { Badge } from "lumir-back-office-ui";
import { TextDisplay } from "lumir-back-office-ui/RmsTextDisplay";

const MidLabel = ({ label = "", required = false }) => {
  return (
    <div className="flex gap-4">
      <TextDisplay
        size="md"
        textData={{
          primary: label,
        }}
        className="w-fit"
      />
      {required && (
        <Badge size="lg" state="error" variant="transparent" rounded="square">
          필수
        </Badge>
      )}
    </div>
  );
};

export { MidLabel };
